export type ItemOrderValidation =
  | { ok: true }
  | { ok: false; reason: "incomplete" | "duplicate" | "unknown" };

export function validateItemOrder(currentIds: string[], requestedIds: string[]): ItemOrderValidation {
  if (new Set(requestedIds).size !== requestedIds.length) return { ok: false, reason: "duplicate" };
  if (requestedIds.length !== currentIds.length) return { ok: false, reason: "incomplete" };

  const current = new Set(currentIds);
  if (requestedIds.some((id) => !current.has(id))) return { ok: false, reason: "unknown" };

  return { ok: true };
}

export function normalizeItemOrder(ids: string[]): Array<{ id: string; sortOrder: number }> {
  return ids.map((id, index) => ({ id, sortOrder: (index + 1) * 10 }));
}

export function moveItemOrder(ids: string[], itemId: string, direction: "up" | "down"): string[] | null {
  const index = ids.indexOf(itemId);
  const targetIndex = direction === "up" ? index - 1 : index + 1;
  if (index < 0 || targetIndex < 0 || targetIndex >= ids.length) return null;

  const next = [...ids];
  [next[index], next[targetIndex]] = [next[targetIndex], next[index]];
  return next;
}
